var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { opacity: ".75", clipPath: "url(#clip0_13983_6800)" },
      React.createElement("path", { d: "M3.482 2.194l2.7 2.7a.15.15 0 0 1 0 .212l-2.7 2.7a.675.675 0 1 0 .954.955L7.595 5.6a.85.85 0 0 0 0-1.202l-3.16-3.16a.675.675 0 1 0-.953.955z", fill: "#B7B7B7", stroke: "#B7B7B7", strokeWidth: ".1" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_13983_6800" },
        React.createElement("path", { fill: "#fff", d: "M0 0h10v10H0z" })
      )
    )
  );
});